import * as React from 'react';

import BranchTabs from '../../../components/Hr/BranchTabs';

// The feature component (Branches) owns the page title, so this stays a thin passthrough.
export default function BranchesPage(): React.JSX.Element {
    return <BranchTabs/>;
}
